// Vortex Auth (Better Auth) client for plasma restaurant portal.
//
// NOTE on naming deviation from the Stage 1 plan:
//   The plan referenced `createAuthClient` from "@vortexnyc/vortex-core/auth/better-auth/client",
//   but that export does not exist. The package exposes `createBetterAuthClient` and
//   `createBetterAuthConvexClient` (see crm's apps/web/src/lib/auth-runtime.better-auth.tsx
//   for the proven production-like pattern). We follow crm and use
//   `createBetterAuthConvexClient` so the client is pre-wired with the Convex +
//   cross-domain plugins required for Convex queries to receive the vortex-auth token
//   once main.tsx is rewired to `ConvexBetterAuthProvider` in subsequent Stage 1 tasks.
import { createBetterAuthConvexClient } from "@vortexnyc/vortex-core/auth/better-auth/client";

import { env } from "~/env";

export const authClient = createBetterAuthConvexClient({
  baseURL: env.PUBLIC_VORTEX_AUTH_URL,
  fetchOptions: {
    credentials: "include",
  },
});

export type AuthClient = typeof authClient;
